var _rect, _rect2, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMountOutside(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "155.9px",
    height: "195px",
    viewBox: "0 0 155.9 195",
    enableBackground: "new 0 0 155.9 195",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0.1,
    fill: "#FFFFFF",
    width: 155.9,
    height: 194.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 132.2,
    y: 39.7,
    fill: "#474746",
    width: 0,
    height: 9.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.9,
    y: 29.9,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 1.138,
    strokeMiterlimit: 10,
    width: 106.3,
    height: 147.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.6,
    y: 38.6,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 1.138,
    strokeMiterlimit: 10,
    width: 88.8,
    height: 130
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#616261",
    strokeWidth: 0.7593,
    strokeMiterlimit: 10,
    d: "M17.4,153.7c0,0,0,2.7-0.5,3.7 c-0.7,1.8,0.5,2.4,0.5,2.4h121.3c0,0,1.2-0.3,0.5-2c-0.5-2.2-0.8-4-0.8-4L17.4,153.7L17.4,153.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#616261",
    strokeWidth: 0.7593,
    strokeMiterlimit: 10,
    d: "M17.4,148.4c0,0,0.1,1.9-0.5,3.7 c-1.2,2.4,0.5,2.4,0.5,2.4h121.3c0,0,1.2-0.3,0.5-2c-0.5-2.2-0.8-4-0.8-4L17.4,148.4L17.4,148.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#616261",
    strokeWidth: 0.7593,
    strokeMiterlimit: 10,
    d: "M20.1,22H138l0.1,115.4c0,0,0,4.4,0.7,7.7 c0.5,1.1,1,3.6-0.6,3.6s-115.8,0-120,0c-3.1,0-0.9-2.9-1.3-8.8c0-1.4,0-117.9,0-117.9L20.1,22L20.1,22z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountOutside);
export default __webpack_public_path__ + "static/media/mount_outside.a19c5417787956eed7447a155720fb43.svg";
export { ForwardRef as ReactComponent };